import jsPDF from "jspdf";
import arabicToThai from "../../../../hook/arabicToThai";
import oneBell from "../../../../assets/images/license/oneBell.png";
import dayjs from "dayjs";
import CurrencyFormat from "../../../../hook/CurrencyFormat";
import "../../../../assets/font/THSarabunNew-normal";
import "../../../../assets/font/THSarabunNew-bold";

export async function createPdfCancelHand(data = [], lawyer) {
  const [convertToThaiNumerals, toThaiWord, numberToThaiText] = arabicToThai();
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  console.log("data", data);
  console.log("lawyer", lawyer);
  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "mm",
    format: "A4",
  });

  data?.forEach((person, index) => {
    if (index !== 0) pdf.addPage();
    if (person.dataType === "vsfhp" || person.dataType === "sfhp") {
      console.log("//สัญญา 2,8", person.CONTNO);

      let y = 20;
      pdf.setFont("THSarabunNew", "normal");
      pdf.setFontSize(16);

      // ส่วนหัว
      pdf.text(`กรุณาส่ง`, 25, y);
      y += 10;

      pdf.text(
        `${person.NAME}  (${person.CONTNO}) (${
          person.cusType === 0 ? "ผู้เช่าซื้อ" : "คนค้ำ " + person.cusType
        })`,
        40,
        y
      );
      y += 5;
      pdf.text(person.ADDRESS.ADDR1 ? person.ADDRESS.ADDR1 : "-", 40, y);

      y += 5;
      pdf.text(
        `ต.${person.ADDRESS.TUMB ? person.ADDRESS.TUMB : "-"} อ.${
          person.ADDRESS.AUMPDES ? person.ADDRESS.AUMPDES : "-"
        } จ.${person.ADDRESS.PROVDES ? person.ADDRESS.PROVDES : "-"}`,
        40,
        y
      );
      y += 5;
      pdf.text(person.ADDRESS.ZIP, 40, y);

      y += 48;
      pdf.setFontSize(14);
      pdf.text(
        `วันที่ ${dayjs(person.datetime)
          .add(543, "year")
          .format("D MMMM YYYY")}`,
        150,
        y
      );
      pdf.text(`เรื่อง   บอกกล่าวให้ชำระหนี้/บอกเลิกสัญญาเช่าซื้อ`, 20, y);
      y += 5;
      pdf.text(
        `เรียน   ${person?.CUSTOMER.SNAM}${person?.CUSTOMER?.NAME1} ${
          person?.CUSTOMER?.NAME2 ? person?.CUSTOMER?.NAME2 : ""
        } (ผู้เช่าซื้อ)`,
        20,
        y
      );

      let xLeft = 30;
      let xRight = 120;
      let yGUARANTORS = y + 5;

      person?.GUARANTORS?.forEach((g, i) => {
        let x = i % 2 === 0 ? xLeft : xRight;

        pdf.text(
          `${g.SNAM} ${g.NAME1} ${g.NAME2} (${
            g.GARNO === 0 ? "ผู้เช่าซื้อ" : "คนค้ำ " + g.GARNO
          })`,
          x,
          yGUARANTORS
        );

        // เมื่อครบคู่ (คนที่ 2 ในแถว) ให้ขึ้นบรรทัดใหม่
        if (i % 2 === 1) {
          yGUARANTORS += 5;
        }
      });

      // หลังจากเขียนผู้ค้ำประกันทั้งหมด อัปเดต y ให้ตรงกับตำแหน่งปัจจุบัน
      y = yGUARANTORS + 15;

      pdf.text(
        `อ้างถึง   สัญญาเช่าซื้อเลขที่ ${person?.CONTNO} ฉบับลงวันที่ ${dayjs(
          person?.LOAN.SDATE
        )
          .add(543, "year")
          .format("D MMMM YYYY")}`,
        15,
        y
      );
      //   เนื้อหา
      const indent = "          "; // เว้นบรรทัดเริ่มต้นแบบย่อหน้า (ประมาณ 8 ช่องว่าง)
      y += 5;
      const content = [
        `${indent}ตามที่ท่านทั้ง     ${toThaiWord(
          person?.GUARANTORS?.length + 1
        )}   คน ได้ทำหนังสือเช่าซื้อและสัญญาค้ำประกันซื้อรถยนต์     ${
          person?.MORTGAGE.BAAB ? person?.MORTGAGE?.BAAB : "-"
        }    ยี่ห้อ     ${
          person?.MORTGAGE?.TYPE ? person?.MORTGAGE?.TYPE : "-"
        }   หมายเลขเครื่องยนต์     ${
          person?.MORTGAGE?.ENGNO ? person?.MORTGAGE?.ENGNO : "-"
        } หมายเลขตัวถังรถยนต์     ${
          person?.MORTGAGE?.STRNO ? person?.MORTGAGE?.STRNO : "-"
        }   หมายเลขทะเบียน  ${
          person?.MORTGAGE?.REGNO ? person?.MORTGAGE?.REGNO : "-"
        } ไปจากบริษัทฯรายละเอียดปรากฎตามสัญญาเช่าซื้อ ฉบับที่อ้างอิงถึง ไปจากบริษัทฯในราคา    ${currencyFormatPoint(
          person?.LOAN.TOTPRC
        )} บาท ตกลงผ่อนชำระ`,
        `ค่าเช่าซื้อให้แก่บริษัทฯ จำนวน     ${
          person?.LOAN?.T_NOPAY
        } งวด   งวดละ 1 เดือน ชำระเดือนละ ${currencyFormatPoint(
          person?.LOAN?.TOT_UPAY
        )} บาท ของเดือนเริ่มชำระงวดแรกภายในวันที่ ${dayjs(person?.LOAN?.FDATE)
          .add(543, "year")
          .format("D MMMM YYYY")} และงวดสุดท้ายชำระในวันที่ ${dayjs(
          person?.LOAN?.LDATE
        )
          .add(543, "year")
          .format(
            "D MMMM YYYY"
          )} โดยผู้ค้ำประกันยินยอมรับผิดหากผู้เช่าซื้อไม่ชำระหนี้ดังกล่าว`,

        `${indent}บัดนี้ปรากฏว่าผู้เช่าซื้อประพฤติผิดสัญญา ไม่ชำระค่าเช่าซื้อให้แก่บริษัทฯ เป็นจำนวน ${
          person?.LOAN?.EXP_TO - person?.LOAN?.EXP_FRM
        } งวด ติดต่อกันตั้งแต่งวดที่  ${
          person?.LOAN?.EXP_FRM
        } เป็นต้นมา เป็นค่าเช่าซื้อที่ค้างชำระถึงวันที่ออกหนังสือฉับบนี้จำนวน     ${currencyFormatPoint(
          person?.LOAN.EXP_AMT
        )} บาท และคงเหลือค่าเช่าซื้อที่ค้างชำระจำนวน เงินทั้งสิ้น  ${currencyFormatPoint(
          person?.LOAN?.TOTPRC - person?.LOAN?.SMPAY + person?.LOAN.EXP_AMT
        )}  บาท`,

        `${indent}ดังนั้นข้าพเจ้าในฐานะผู้รับมอบอำนาจจากบริษัทฯ จึงขอให้ท่านทั้ง ${toThaiWord(
          person?.GUARANTORS?.length + 1
        )}  คน นำจำนวนเงินค่าเช่าซื้อที่ค้างชำระดังกล่าว
ข้างต้นพร้อมภาษีค่าเพิ่ม เบี้ยปรับค่าใช้จ่าย และเงินอื่นใดที่ต้องชำระให้ครบทันงวด ไปชำระที่บริษัทฯ ภายในกำหนด 30 วัน นับตั้งแต่วันที่ท่านได้รับหนังสือทวงถามฉบับนี้หากท่านทั้ง ${toThaiWord(
          person?.GUARANTORS?.length + 1
        )}   คน เพิกเฉยไม่ดำเนินการภายในเวลาดังกล่าวข้างต้นแล้ว บริษัทฯ ขอถือว่าหนังสือฉบับนี่เป็นการบอกเลิกสัญญาเช่าซืิ้อ ขอให้ถือว่าหนังสือฉบับนี้เป็นการบอกเลิกสัญญาเช่าซื้อ ฉบับดังกล่าว และให้ท่าน ทั้ง ${toThaiWord(
          person?.GUARANTORS?.length + 1
        )} คนร่วมกันหรือแทนกันส่งมอบรถยนต์ที่เช่าซื้อคืนบริษัทฯในสภาพสมบูรณ์เรียบร้อยใช้การได้ดีหากท่านไม่สามารถมอบรถยนต์ คืนบริษัทฯ ให้ใช้ราคารถยนต์แทนจำนวน      ${currencyFormatPoint(
          person?.LOAN?.TOTPRC - person?.LOAN?.SMPAY + person?.LOAN.EXP_AMT
        )}    บาท       ${numberToThaiText(
          person?.LOAN?.TOTPRC - person?.LOAN?.SMPAY + person?.LOAN.EXP_AMT
        )} ${
          person?.LOAN?.PAYAMTAROTHR
            ? "ค่าติดตามทวงถามเป็นเงิน " +
              currencyFormatPoint(person?.LOAN?.PAYAMTAROTHR) +
              " บาท"
            : ""
        }`,

        `${indent}นับแต่วันที่ผิดนัดดอกเบี้ยในอัตราร้อยละ 15 ต่อปีไปชำระให้แก่บริษัทฯ ณ ที่ทำการบริษัทฯตามที่อยู่ข้างบนหนังสือฉบับนี้ใน เวลาทำการปกติ หากท่านเพิกเฉยโดยมิดำเนินการดังกล่าวภายในเวลาที่กำหนดข้าพเจ้ามีความเสียใจที่จะต้องดำเนินการกับท่านตาม กฎหมายต่อไป`,
      ];

      content.forEach((line) => {
        const splitText = pdf.splitTextToSize(line, 170);
        pdf.text(splitText, 20, y);
        y += splitText.length * 6;
      });

      pdf.text(`ขอแสดงความนับถือ`, 47, y + 2); // (x, y)
      let imageWidthImg = 25; // Adjust width to fit your needs
      let imageHeightImg = 15; // Adjust height to fit your needs
      pdf.addImage(
        lawyer.image,
        "PNG",
        50,
        y + 3,
        imageWidthImg - 3,
        imageHeightImg - 3
      );

      pdf.text(
        `(${lawyer ? lawyer?.lawyer.fname : "                        "}  ${
          lawyer ? lawyer?.lawyer.lname : "                         "
        })`,
        lawyer.lawyer.value === 3 ? 40 : 50,
        y + 20
      ); // (x, y)
      //   pdf.text("(ร้อยตำรวจโทพงษ์ศรา วงษ์วีระขันธ์)", 40, y + 20); // (x, y)
      pdf.text("ทนายความประจำบริษัทฯ", 45, y + 24); // (x, y)
      pdf.text("ผู้รับมอบอำนาจ", 50, y + 29); // (x, y)
      pdf.text(`ขอแสดงความนับถือ`, 145, y + 2); // (x, y)
      pdf.addImage(oneBell, "PNG", 145, y + 3, imageWidthImg, imageHeightImg);

      pdf.text(`( จิราภรณ์  พวงทอง)`, 145, y + 20); // (x, y)
      pdf.text("เลขานุการแผนกเร่งรัด", 145, y + 24); // (x, y)
      pdf.text("ผู้ออกจดหมาย", 150, y + 29); // (x, y)
      pdf.setFont("THSarabunNew", "bold");
      pdf.text(
        `หมายเหตุ : ยอดที่แจ้งเป็นยอด ณ วันที่ ${dayjs(person.datetime)
          .add(543, "year")
          .format(
            "D MMMM YYYY"
          )} หากมาชำระหลังจากนี้อาจมีการเปลี่ยนแปลง ยอดที่แจ้งยังไม่รวมค่าใช้`,
        15,
        y + 40
      );
      pdf.text(`จ่ายติดตามทวงถาม และเบี้ยปรับ`, 31, y + 45); // (x, y)
    } else if (person.dataType === "lsfhp") {
      console.log("//สัญญา 1", person.CONTNO);
      //สัญญา 1
      let y = 20;
      pdf.setFont("THSarabunNew", "normal");
      pdf.setFontSize(16);

      // ส่วนหัว
      pdf.text(`กรุณาส่ง`, 25, y);
      y += 10;

      pdf.text(
        `${person.NAME}  (${person.CONTNO}) (${
          person.cusType === 0 ? "ผู้กู้/จำนอง" : "คนค้ำ " + person.cusType
        })`,
        40,
        y
      );
      y += 5;
      pdf.text(person.ADDRESS.ADDR1 ? person.ADDRESS.ADDR1 : "-", 40, y);

      y += 5;
      pdf.text(
        `ต.${person.ADDRESS.TUMB ? person.ADDRESS.TUMB : "-"} อ.${
          person.ADDRESS.AUMPDES ? person.ADDRESS.AUMPDES : "-"
        } จ.${person.ADDRESS.PROVDES ? person.ADDRESS.PROVDES : "-"}`,
        40,
        y
      );
      y += 5;
      pdf.text(person.ADDRESS.ZIP, 40, y);

      y += 48;
      pdf.setFontSize(14);
      pdf.text(
        `วันที่ ${dayjs(person.datetime)
          .add(543, "year")
          .format("DD MMMM YYYY")}`,
        150,
        y
      );
      pdf.text(
        `เรื่อง   ขอให้ชำระหนี้/บอกกล่าวบังคับจำนอง เลขที่ (${person.CONTNO})`,
        20,
        y
      );
      y += 5;
      pdf.text(
        `เรียน   ${person.CUSTOMER?.SNAM}${person.CUSTOMER?.NAME1} ${
          person.CUSTOMER?.NAME2 ? person.CUSTOMER?.NAME2 : ""
        } (ผู้กู้/จำนอง)`,
        20,
        y
      );

      let xLeft = 30;
      let xRight = 120;
      let yGUARANTORS = y + 5;

      person?.GUARANTOR?.forEach((g, i) => {
        let x = i % 2 === 0 ? xLeft : xRight;

        pdf.text(
          `${g.SNAM} ${g.NAME1} ${g.NAME2} (${
            g.GARNO === 0 ? "ผู้กู้/จำนอง" : "คนค้ำ " + g.GARNO
          })`,
          x,
          yGUARANTORS
        );

        // เมื่อครบคู่ (คนที่ 2 ในแถว) ให้ขึ้นบรรทัดใหม่
        if (i % 2 === 1) {
          yGUARANTORS += 5;
        }
      });

      // หลังจากเขียนผู้ค้ำประกันทั้งหมด อัปเดต y ให้ตรงกับตำแหน่งปัจจุบัน
      y = yGUARANTORS + 15;
      // ==== CONTENT (replace เฉพาะบล็อกนี้) ====

      // กันคำสำคัญไม่ให้ถูกตัดบรรทัด
      const NBSP = "\u00A0";
      const nowrap = (s) => String(s ?? "").replace(/ /g, NBSP);
      const glue = (...parts) => parts.filter(Boolean).join(NBSP); // ต่อคำด้วย NBSP

      // พารามิเตอร์ย่อหน้า
      const LEFT = 20; // margin ซ้าย
      const WIDTH = 170; // ความกว้างเนื้อหา (mm)
      const INDENT = 10; // ย่อบรรทัดแรก (mm)
      const LINE_H = 7; // ระยะบรรทัด (mm)
      const PARA_GAP = 2.5; // ระยะเว้นระหว่างย่อหน้า (mm)

      // helper: วาดย่อหน้าแบบ "ย่อเฉพาะบรรทัดแรก"
      function drawParagraph(
        pdf,
        text,
        y,
        {
          left = LEFT,
          width = WIDTH,
          indent = INDENT,
          lineH = LINE_H,
          paraGap = PARA_GAP,
        } = {}
      ) {
        // ตัด \n ที่แฝงมา แต่ไม่ลบช่องว่างต้นประโยค
        const cleaned = String(text ?? "").replace(/\s*\n\s*/g, " ");
        const lines = pdf.splitTextToSize(cleaned, width);
        lines.forEach((line, i) => {
          const x = i === 0 ? left + indent : left; // ย่อเฉพาะบรรทัดแรก
          pdf.text(line, x, y);
          y += lineH;
        });
        return y + paraGap; // เว้นวรรคย่อหน้า
      }

      y += 5;

      // เตรียมข้อความ โดยจับคู่ "ตัวเลข + หน่วย" และ "วันที่" ด้วย NBSP
      const amountLoan = glue(currencyFormatPoint(person?.LOAN.NCSHPRC), "บาท");
      const amountTotal = glue(currencyFormatPoint(person?.LOAN.TOTPRC), "บาท");
      const amountInstal = glue(
        currencyFormatPoint(person?.LOAN.TOT_UPAY),
        "บาท"
      );
      const startDate = nowrap(
        dayjs(person?.LOAN.FDATE).add(543, "year").format("DD MMMM YYYY")
      );
      const lastDueDate = nowrap(
        dayjs(person?.LOAN.LDATE).add(543, "year").format("DD MMMM YYYY")
      );
      const signDate = dayjs(person?.LOAN.FDATE).format("DD"); // ใช้ร่วมกับคำว่า "ของเดือน"

      const p1 =
        `ตามที่ท่าน ${nowrap(person?.CUSTOMER.SNAM)} ${
          person?.CUSTOMER.NAME1
        } ${
          person?.CUSTOMER.NAME2 ? person?.CUSTOMER.NAME2 : null
        }ได้กู้ยืมเงินไปจาก บริษัท วัน มันนี่ จำกัด (สำนักงานใหญ่) ` +
        `เป็นเงินที่จำนอง จำนวน ${amountLoan}` +
        `(${numberToThaiText(
          person?.LOAN.NCSHPRC
        )}) คิดดอกเบี้ยอัตราร้อยละ 15 ต่อปี และตกลงนำส่งดอกเบี้ยเป็นรายเดือน ` +
        `โดยกำหนดชำระงวดละ ${amountInstal} กำหนดชำระงวดแรกวันที่ ${startDate} ` +
        `และงวดถัดไปชำระทุกวันที่ ${signDate} ของเดือนรวมเป็นเงิน ตลอดสัญญาทั้งสิ้น ${amountTotal} ` +
        `และท่านได้ทำสัญญาจำนองที่ดิน เลขที่ ${person?.MORTGAGE.COLOR ?? ""} ${
          person?.MORTGAGE.STRNO ?? ""
        } ` +
        `ต.${person?.MORTGAGE.BAAB ?? ""} อ.${person?.MORTGAGE.MODEL ?? ""} จ.${
          person?.MORTGAGE.TYPE ?? ""
        } ` +
        `เป็นประกันหนี้กู้ยืม โดยผู้กู้ได้รับเงินกู้ครบถ้วนแล้ว`;

      const arrearAmount = currencyFormatPoint(person?.LOAN.EXP_AMT);
      const arrearAmountThai = numberToThaiText(person?.LOAN.EXP_AMT);

      const p2 =
        `บัดนี้ปรากฏว่าผู้กู้ผิดนัดและค้างชำระ งวดที่ ${person?.LOAN.EXP_FRM} - ${person?.LOAN.EXP_TO} ` +
        `ซึ่งกำหนดชำระวันที่ ${lastDueDate} รวมค้าง ${person?.LOAN.EXP_PRD} งวด ` +
        `เป็นจำนวนเงิน ${glue(arrearAmount, "บาท")} (${arrearAmountThai}) ` +
        `จึงขอให้ท่านนำเงินดังกล่าวมาชำระและไถ่ถอนจำนอง ณ ที่ทำการของผู้ให้กู้และผู้รับจำนอง ` +
        `ภายใน 60 วันนับแต่วันที่ได้รับหนังสือฉบับนี้ หากพ้นกำหนดดังกล่าวแล้วยังเพิกเฉย ` +
        `ผู้ให้กู้และผู้รับจำนองจะดำเนินการตามกฎหมายต่อไป`;

      const p3 = `หากท่านได้ชำระเงินจำนวนดังกล่าวเรียบร้อยแล้ว ทางบริษัทฯ ขออภัยมา ณ โอกาสนี้`;

      // วาดย่อหน้า (ย่อเฉพาะบรรทัดแรก)
      y = drawParagraph(pdf, p1, y);
      y = drawParagraph(pdf, p2, y);
      y = drawParagraph(pdf, p3, y);

      pdf.text(`ขอแสดงความนับถือ`, 47, y + 22); // (x, y)
      let imageWidthImg = 25; // Adjust width to fit your needs
      let imageHeightImg = 15; // Adjust height to fit your needs
      pdf.addImage(
        lawyer.image,
        "PNG",
        50,
        y + 23,
        imageWidthImg - 3,
        imageHeightImg - 3
      );

      pdf.text(
        `(${lawyer ? lawyer?.lawyer.fname : "                        "}  ${
          lawyer ? lawyer?.lawyer.lname : "                         "
        })`,
        lawyer?.lawyer.value === 3 ? 40 : 50,
        y + 40
      ); // (x, y)
      //   pdf.text("(ร้อยตำรวจโทพงษ์ศรา วงษ์วีระขันธ์)", 40, y + 40); // (x, y)
      pdf.text("ทนายความประจำบริษัทฯ", 45, y + 44); // (x, y)
      pdf.text("ผู้รับมอบอำนาจ", 50, y + 49); // (x, y)
      pdf.text(`ขอแสดงความนับถือ`, 145, y + 22); // (x, y)
      pdf.addImage(oneBell, "PNG", 145, y + 23, imageWidthImg, imageHeightImg);

      pdf.text(`( จิราภรณ์  พวงทอง)`, 145, y + 40); // (x, y)
      pdf.text("เลขานุการแผนกเร่งรัด", 145, y + 44); // (x, y)
      pdf.text("ผู้ออกจดหมาย", 150, y + 49); // (x, y)
      pdf.setFont("THSarabunNew", "bold");
      pdf.text(
        `หมายเหตุ : ยอดที่แจ้งเป็นยอด ณ วันที่ ${dayjs(person.datetime)
          .add(543, "year")
          .format(
            "D MMMM YYYY"
          )} หากมาชำระหลังจากนี้อาจมีการเปลี่ยนแปลง ยอดที่แจ้งยังไม่รวมค่าใช้`,
        15,
        y + 70
      );
      pdf.text(`จ่ายติดตามทวงถาม และเบี้ยปรับ`, 31, y + 75); // (x, y)
    } else {
      console.log("//สัญญา 3", person.CONTNO);
      //สัญญา 3
      let y = 20;
      pdf.setFont("THSarabunNew", "normal");
      pdf.setFontSize(16);

      // ส่วนหัว
      pdf.text(`กรุณาส่ง`, 25, y);
      y += 10;

      pdf.text(
        `${person.NAME}  (${person.CONTNO}) (${
          person.cusType === 0 ? "ผู้กู้" : "ผู้ค้ำประกัน " + person.cusType
        })`,
        40,
        y
      );
      y += 5;
      pdf.text(person.ADDRESS.ADDR1 ? person.ADDRESS.ADDR1 : "-", 40, y);

      y += 5;
      pdf.text(
        `ต.${person.ADDRESS.TUMB ? person.ADDRESS.TUMB : "-"} อ.${
          person.ADDRESS.AUMPDES ? person.ADDRESS.AUMPDES : "-"
        } จ.${person.ADDRESS.PROVDES ? person.ADDRESS.PROVDES : "-"}`,
        40,
        y
      );
      y += 5;
      pdf.text(person.ADDRESS.ZIP, 40, y);

      y += 48;
      pdf.setFontSize(14);
      pdf.text(
        `วันที่ ${dayjs(person.datetime)
          .add(543, "year")
          .format("D MMMM YYYY")}`,
        150,
        y
      );
      pdf.text(`เรื่อง   บอกเลิกสัญญากู้ยืม เลขที่ (${person.CONTNO})`, 20, y);
      y += 5;
      pdf.text(
        `เรียน    ${person?.CUSTOMER.SNAM}${person?.CUSTOMER?.NAME1} ${
          person?.CUSTOMER?.NAME2 ? person?.CUSTOMER?.NAME2 : ""
        } (${
          person.cusType === 0 ? "ผู้กู้" : "ผู้ค้ำประกัน " + person.cusType
        })`,
        20,
        y
      );

      let xLeft = 30;
      let xRight = 120;
      let yGUARANTORS = y + 5;

      // เรียง GARNO จากน้อย -> มาก (0,1,2,...)  ถ้าไม่มีค่าให้ไปท้ายสุด
      const sortedGuarantors = [...(person?.GUARANTORS ?? [])].sort((a, b) => {
        const ga = Number(a?.GARNO ?? Number.POSITIVE_INFINITY);
        const gb = Number(b?.GARNO ?? Number.POSITIVE_INFINITY);
        return ga - gb; // asc
      });

      sortedGuarantors.forEach((g, i) => {
        const x = i % 2 === 0 ? xLeft : xRight;

        pdf.text(
          `${g.SNAM} ${g.NAME1} ${g.NAME2} (${
            Number(g?.GARNO) === 0
              ? "ผู้กู้"
              : `ผู้ค้ำประกัน ${Number(g?.GARNO)}`
          })`,
          x,
          yGUARANTORS
        );

        // ครบ 2 คนในแถวแล้วค่อยขึ้นบรรทัดใหม่
        if (i % 2 === 1) yGUARANTORS += 5;
      });

      // หลังจากเขียนผู้ค้ำประกันทั้งหมด อัปเดต y ให้ตรงกับตำแหน่งปัจจุบัน
      y = yGUARANTORS + 15;
      const signDate = dayjs(person.LOAN.SDATE)
        .add(543, "year")
        .format("DD MMMM YYYY");
      //   เนื้อหา
      const indent = "          "; // เว้นบรรทัดเริ่มต้นแบบย่อหน้า (ประมาณ 8 ช่องว่าง)
      y += 5;
      const content = [
        `${indent}ตามที่ท่าน ${person.CUSTOMER.SNAM} ${person.CUSTOMER.NAME1} ${
          person.CUSTOMER.NAME2
        } ทำสัญญากู้ยืมเงิน วันที่ ${signDate}  โดยได้นำรถยนต์ยี่ห้อ ${
          person?.MORTGAGE.TYPE ? person?.MORTGAGE.TYPE : "-"
        }  
รุ่น ${person?.MORTGAGE.BAAB ? person?.MORTGAGE.BAAB : "-"}  สี ${
          person?.MORTGAGE.COLOR ? person?.MORTGAGE.COLOR : "-"
        } ทะเบียน  ${person?.MORTGAGE.REGNO ? person?.MORTGAGE.REGNO : "-"}   ${
          person?.MORTGAGE.DORECV ? person?.MORTGAGE.DORECV : "-"
        } เลขเครื่อง  ${
          person?.MORTGAGE.ENGNO ? person?.MORTGAGE.ENGNO : "-"
        }  เลขตัวถัง   ${
          person?.MORTGAGE.STRNO ? person?.MORTGAGE.STRNO : "-"
        } เป็นหลักประกัน ในการกู้ยืมเงินทางธุรกิจ ไปจากผู้ให้กู้เป็นจำนวนเงินทั้งสิ้น ${currencyFormatPoint(
          person?.LOAN.TOTPRC
        )} บาท ${numberToThaiText(
          person?.LOAN.TOTPRC
        )}  โดยมีผู้ค้ำประกัน ได้ทำสัญญาค้ำประกัน หากผู้กู้ไม่ชำระยินยอมชำระแทนจนครบถ้วน`,

        `${indent}บัดนี้ปรากฏว่าผู้กู้ได้ค้างชำระค่างวด งวดที่ ${
          person?.LOAN.EXP_FRM
        } - ${person?.LOAN?.EXP_TO} ซึ่งกำหนดชำระ  ${dayjs(person?.LOAN.DUEDATE)
          .add(543, "year")
          .format("D MMMM YYYY")} แล้วรวม ${
          person?.LOAN?.EXP_PRD
        } งวด เป็นจำนวนเงิน  ${currencyFormatPoint(
          person?.LOAN.EXP_AMT
        )} บาท ${numberToThaiText(
          person?.LOAN.EXP_AMT
        )} ผู้ให้กู้จึงขอให้ท่านนำเงินจำนวนดังกล่าวมาชำระให้เสร็จสิ้น ณ ที่ทำการผู้ให้กู้ ภายใน 30 วัน นับตั้งแต่วันที่ท่านได้รับหรือถือว่าได้รับหนังสือฉบับนี้`,

        `${indent}หากครบกำหนดดังกล่าวข้างต้น แล้วท่านเพิกเฉยไม่ดำเนินการตามหนังสือฉบับนี้ ผู้ให้กู้ขอถือว่าหนังสือฉบับนี้เป็นหนังสือบอก เลิกสัญญาดังกล่าวข้างต้น หากท่านประสงค์จะส่งมอบรถยนต์ที่เป็นหลักประกันเพื่อใช้หนี้ดังกล่าวข้างต้นขอให้ส่งมอบรถยนต์ที่ใช้เป็น หลักประกันในสภาพที่ใช้การได้ดี ภายใน 30 วัน นับตั้งแต่วันที่ครบกำหนดชำระหนี้ดังกล่าวข้างต้นหากท่านเพิกเฉยผู้ให้กู้มีความจำ เป็นต้องดำเนินคดีกับท่านทันที และท่านยังต้องรับผิดชอบในความเสียหายอันพึงเกิดขึ้นทั้งปวงด้วย`,

        `${indent}หากท่านมีการชำระเงินจำนวนดังกล่าวเป็นที่เรียบร้อยแล้วทางผู้ให้กู้ ต้องขออภัย ณ โอกาสนี้`,
      ];

      content.forEach((line) => {
        const splitText = pdf.splitTextToSize(line, 170);
        pdf.text(splitText, 20, y);
        y += splitText.length * 6;
      });

      pdf.text(`ขอแสดงความนับถือ`, 47, y + 2); // (x, y)
      let imageWidthImg = 25; // Adjust width to fit your needs
      let imageHeightImg = 15; // Adjust height to fit your needs
      pdf.addImage(
        lawyer.image,
        "PNG",
        50,
        y + 3,
        imageWidthImg - 3,
        imageHeightImg - 3
      );

      pdf.text(
        `(${lawyer ? lawyer?.lawyer.fname : "                        "}  ${
          lawyer ? lawyer?.lawyer.lname : "                         "
        })`,
        lawyer?.lawyer.value === 3 ? 40 : 50,
        y + 20
      ); // (x, y)
      //   pdf.text("(ร้อยตำรวจโทพงษ์ศรา วงษ์วีระขันธ์)", 40, y + 20); // (x, y)
      pdf.text("ทนายความประจำบริษัทฯ", 45, y + 24); // (x, y)
      pdf.text("ผู้รับมอบอำนาจ", 50, y + 29); // (x, y)
      pdf.text(`ขอแสดงความนับถือ`, 145, y + 2); // (x, y)
      pdf.addImage(oneBell, "PNG", 145, y + 3, imageWidthImg, imageHeightImg);

      pdf.text(`( จิราภรณ์  พวงทอง)`, 145, y + 20); // (x, y)
      pdf.text("เลขานุการแผนกเร่งรัด", 145, y + 24); // (x, y)
      pdf.text("ผู้ออกจดหมาย", 150, y + 29); // (x, y)
      pdf.setFont("THSarabunNew", "bold");
      pdf.text(
        `หมายเหตุ : ยอดที่แจ้งเป็นยอด ณ วันที่ ${dayjs(person.datetime)
          .add(543, "year")
          .format(
            "D MMMM YYYY"
          )} หากมาชำระหลังจากนี้อาจมีการเปลี่ยนแปลง ยอดที่แจ้งยังไม่รวมค่าใช้`,
        15,
        y + 40
      );
      pdf.text(`จ่ายติดตามทวงถาม และเบี้ยปรับ`, 31, y + 45); // (x, y)
    }
  });

  // เพิ่มหน้าใหม่
  pdf.addPage();

  // ตั้งค่าฟอนต์
  pdf.setFont("THSarabunNew", "normal");
  pdf.setFontSize(16);

  // config layout
  let finalYLeft = 20;
  let finalYRight = 20;
  let leftX = 10;
  let rightX = 115; // จุดเริ่มคอลัมน์ขวา
  let rowHeight = 30; // ความสูงต่อคน
  let count = 0;
  let columnCount = 0;

  data.forEach((person, index) => {
    const x = count % 2 === 0 ? leftX : rightX;
    let y = count % 2 === 0 ? finalYLeft : finalYRight;

    // --- ชื่อ + ประเภท ---
    const nameType = `${person.NAME} (${
      person.cusType === 0
        ? person.dataType === "lsfhp"
          ? "ผู้กู้"
          : "ผู้เช่าซื้อ"
        : "คนค้ำ " + person.cusType
    }) (${person.CONTNO})`;
    pdf.text(nameType, x, y);
    y += 6;

    // --- ที่อยู่ บรรทัด 1 ---
    if (person.ADDRESS?.ADDR1) {
      pdf.text(`เลขที่ ${person.ADDRESS.ADDR1}`, x, y);
      y += 6;
    }

    // --- ที่อยู่ บรรทัด 2 ---
    const addrLine2 = `ต.${person.ADDRESS.TUMB} อ.${person.ADDRESS.AUMPDES} จ.${person.ADDRESS.PROVDES}`;
    pdf.text(addrLine2, x, y);
    y += 6;

    // --- ZIP ---
    pdf.text(person.ADDRESS.ZIP || "", x, y);

    // --- อัปเดต Y ตามคอลัมน์ ---
    if (count % 2 === 0) {
      finalYLeft += rowHeight;
    } else {
      finalYRight += rowHeight;
      columnCount++;
    }

    count++;

    // --- ถ้าเกิน 9 แถวต่อคอลัมน์ (18 คน) ขึ้นหน้าใหม่ ---
    if (columnCount > 8) {
      columnCount = 0;
      console.log(" columnCount 0", columnCount);
      pdf.addPage();
      pdf.setFont("THSarabunNew", "normal");
      pdf.setFontSize(16);
      finalYLeft = 20;
      finalYRight = 20;
    }
  });

  const pdfBlob = pdf.output("blob");
  const pdfUrl = URL.createObjectURL(pdfBlob);
  window.open(pdfUrl);
  pdf.save(`จดหมายบอกเลิกมือ ${dayjs().format("DD MM YY")}.pdf`);
}
